module.exports = __webpack_public_path__ + "static/img/lunbo.7b5bbc22.jpg";